import serialize from "form-serialize";
import { Ref, ref } from "vue";

type Settings = {
  lists: string[];
  redirect?: string;
  callback?: () => string | undefined;
};

export function useSubmitForm(form: Ref<HTMLFormElement | undefined>, _settings: Settings) {
  const state = ref<"idle" | "submitting" | "submitted" | "error">("idle");

  const values = ref()

  const settings = _settings;

  async function modifySettings (newSettings: Partial<Settings>) {
    Object.assign(settings, newSettings)
  }

  async function onSubmit() {
    if (state.value != "idle") return;

    values.value = serialize(form.value!, {
      hash: true
    });

    state.value = "submitting";

    const url = `https://esp.ouapis.org/databases/1847712/contact`;

    try {
      await fetch(url, {
        method: "post",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          callback: _settings.callback?.(),
          contactLists: settings.lists,
          fields: {
            ...values.value
          }
        })
      });

      if (settings.redirect) {
        location.href = settings.redirect
      }

      state.value = "submitted";
    } catch (error) {
      state.value = "error";
    }
  }

  return {
    onSubmit,
    modifySettings,
    state,
    values
  };
}
